function ccInitTimer(){

  const timerEl = document.getElementById("cc-timer");
  const dateEl  = document.getElementById("cc-date");
  if(!timerEl || !dateEl) return;

  // Delivery date (5 days)
  const delivery = new Date();
  delivery.setDate(delivery.getDate() + 5);
  dateEl.innerText = delivery.toLocaleDateString("en-US", {
    weekday: "short", month: "short", day: "numeric"
  });

  // Daily 5:30 PM cutoff
  function nextCutoff(){
    const now = new Date();
    const cutoff = new Date();
    cutoff.setHours(17,30,0,0);
    if(now > cutoff) cutoff.setDate(cutoff.getDate() + 1);
    return cutoff;
  }

  let cutoffTime = nextCutoff();

  function runTimer(){
    const now = new Date();
    let diff = cutoffTime - now;

    if(diff <= 0){
      cutoffTime = nextCutoff();
      diff = cutoffTime - now;
    }

    let h = Math.floor(diff / 36e5);
    let m = Math.floor((diff % 36e5) / 6e4);
    let s = Math.floor((diff % 6e4) / 1000);

    timerEl.innerText =
      h.toString().padStart(2,"0") + ":" +
      m.toString().padStart(2,"0") + ":" +
      s.toString().padStart(2,"0");
  }

  runTimer();
  setInterval(runTimer, 1000);
}

// Shopify section reload support
document.addEventListener("DOMContentLoaded", ccInitTimer);
document.addEventListener("shopify:section:load", ccInitTimer);
